import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { enterRoom } from "../../store/appSlice";
import {
  SidebarOptionChannel,
  SidebarOptionContainer,
} from "./SidebarOption.elements";
import { Link } from "react-router-dom";
import Modal from "../Modal/Modal";

function SidebarOption({ Icon, title, addChannelOption, id, toggleSidebar }) {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  const addChannel = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const selectChannel = () => {
    toggleSidebar();
    if (id) {
      dispatch(
        enterRoom({
          roomId: id,
        })
      );
    }
  };

  return (
    <React.Fragment>
      {showModal && <Modal onClose={closeModal} />}
      <SidebarOptionContainer
        onClick={addChannelOption ? addChannel : selectChannel}
      >
        {Icon && <Icon fontSize="small" style={{ padding: 10 }} />}
        {Icon ? (
          <h3>{title}</h3>
        ) : (
          <SidebarOptionChannel>
            <Link to={`/channel/${id}`}>
              <span>#</span> {title}
            </Link>
          </SidebarOptionChannel>
        )}
      </SidebarOptionContainer>
    </React.Fragment>
  );
}

export default SidebarOption;
